"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AddQuoteDetails_1 = __importDefault(require("../Utils/AddQuoteDetails"));
var FeatureFlag_1 = __importStar(require("@CommonFrontendBackend/FeatureFlag"));
var MountReactComponent_1 = __importDefault(require("@CommonFrontend/MountReactComponent/MountReactComponent"));
var InlineAcceptHeader_1 = require("../Utils/InlineAcceptHeader");
var SecuredByQwilr_1 = require("../Utils/SecuredByQwilr");
var lodash_1 = __importDefault(require("lodash"));
var react_1 = __importDefault(require("react"));
var AcceptForm_1 = require("../AcceptForm/AcceptForm");
var transformAngularSteps = function (stepMap) {
    var customForm = stepMap.customForm
        ? {
            fields: stepMap.customForm[0].fields,
            registerImperativeHandlers: stepMap.customForm[0].registerImperativeHandlers,
        }
        : undefined;
    return { customForm: customForm };
};
var SingleAccept = (function () {
    function SingleAccept($q, createUi, acceptData, acceptButton, unbuiltSteps, attemptAccept, di, environment, Tooltip, closeCurrent, closeAll, options, getPoweredByQwilr, acceptUtils, AsyncButton, usingFeature, acceptTelemetry, settings) {
        var _this = this;
        var acceptButtonElem = null;
        var steps = [];
        var isUsingInlineForm = !usingFeature(FeatureFlag_1.default.OptOutNewEditor);
        var isUsingAcceptBlockPrintMode = usingFeature(FeatureFlag_1.default.AcceptBlockPrintMode);
        var isPrintMode = isUsingAcceptBlockPrintMode && di.has("isPrintMode") ? di.get("isPrintMode") : false;
        var init = function () {
            var acceptSuffix;
            acceptButtonElem = new AsyncButton(validateAndAccept, getAcceptButtonText(), {
                initialState: "idle",
                center: !isUsingInlineForm,
            });
            unbuiltSteps = lodash_1.default.map(unbuiltSteps, function (step) {
                if (step.additionalParams == null) {
                    step.additionalParams = {};
                }
                if (step.name === "accept") {
                    step.additionalParams.legalEntityLabel = "Organization";
                    step.additionalParams.hideNameIfFilled = true;
                }
                return step;
            });
            var getQwilrButton = function () {
                if (isUsingInlineForm) {
                    return (0, SecuredByQwilr_1.mountAcceptFlowSecuredByQwilrBtn)((0, MountReactComponent_1.default)(createUi));
                }
                else {
                    return getPoweredByQwilr(acceptUtils.utmMedium);
                }
            };
            steps = di.invoke(require("../Utils/StepBuilder"), null, {
                acceptData: acceptData,
                unbuiltSteps: unbuiltSteps,
                setErrorMsg: setErrorMsg,
            });
            if (acceptData.name) {
                acceptSuffix = " for ".concat(acceptData.name);
            }
            else {
                acceptSuffix = "";
            }
            if (acceptData.name) {
                acceptData.isPrefilled = true;
            }
            else {
                acceptData.isPrefilled = false;
            }
            var stepsMap = lodash_1.default.groupBy(steps, "name");
            var customForm = transformAngularSteps(stepsMap).customForm;
            _this.ui = createUi(require("./SingleAccept.html"), {
                steps: steps,
                poweredByQwilr: getQwilrButton(),
                acceptSuffix: acceptSuffix,
                close: closeAll,
                showBranding: acceptUtils.showBranding,
                acceptButtonUi: acceptButtonElem.ui,
                isUsingInlineForm: isUsingInlineForm,
                stepsMap: stepsMap,
                isPrintMode: isPrintMode,
                acceptForm: (0, MountReactComponent_1.default)(createUi, di)(react_1.default.createElement(AcceptForm_1.AcceptForm, {
                    printMode: isPrintMode,
                    visualMode: isPrintMode ? "simple" : "standard",
                    customForm: customForm,
                })),
                $init: function ($scope) {
                    return ($scope.ui.inlineHeader = (0, InlineAcceptHeader_1.mountHeader)((0, MountReactComponent_1.default)(createUi), {
                        telemetry: acceptTelemetry,
                        onClose: function () {
                            return $scope.$apply(closeAll);
                        },
                        screen: InlineAcceptHeader_1.AcceptScreen.SingleAccept,
                        onBack: options.canGoBack ? function () { return $scope.$apply(closeCurrent); } : undefined,
                    }));
                },
                canGoBack: function () {
                    return options.canGoBack;
                },
                goBack: closeCurrent,
                autoFill: function () {
                    if (di.has("isPreviewMode") && di.get("isPreviewMode")) {
                        this.previewFill();
                        return;
                    }
                    return this.publicPageFill();
                },
                previewFill: function () {
                    return steps.forEach(function (step) { var _a; return (_a = step.previewAutoFill) === null || _a === void 0 ? void 0 : _a.call(step); });
                },
                publicPageFill: function () {
                    if (environment === "production") {
                        return;
                    }
                    return steps.forEach(function (step) { var _a; return (_a = step.devFill) === null || _a === void 0 ? void 0 : _a.call(step); });
                },
            });
        };
        var getAcceptButtonText = function () {
            if ((0, FeatureFlag_1.isUsingTCDC)(usingFeature)) {
                if (acceptButton.customLabel) {
                    return acceptButton.customLabel;
                }
                else {
                    return "Accept";
                }
            }
            else {
                return "ACCEPT";
            }
        };
        var setErrorMsg = function (message, selector) {
            var position;
            if (selector != null) {
                position = "top";
            }
            else {
                selector = ".accept-single-accept .accept-button-v2-wrapper";
                position = "bottom";
            }
            var tooltip = di.make(Tooltip, {
                targetSelector: selector,
                options: {
                    container: ".accept-single-accept",
                    position: position,
                    stringContent: message,
                    spacing: 5,
                    customTheme: "error-theme",
                },
            });
            tooltip.show();
            return tooltip;
        };
        var validateAndAccept = function () {
            return $q.resolve().then(function () {
                var e_1, _a, e_2, _b;
                var acceptSteps = Array.from(steps);
                try {
                    for (var acceptSteps_1 = __values(acceptSteps), acceptSteps_1_1 = acceptSteps_1.next(); !acceptSteps_1_1.done; acceptSteps_1_1 = acceptSteps_1.next()) {
                        var step = acceptSteps_1_1.value;
                        if (step.validate != null && !step.validate()) {
                            return $q.reject();
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (acceptSteps_1_1 && !acceptSteps_1_1.done && (_a = acceptSteps_1.return)) _a.call(acceptSteps_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                var finalising = [];
                try {
                    for (var acceptSteps_2 = __values(acceptSteps), acceptSteps_2_1 = acceptSteps_2.next(); !acceptSteps_2_1.done; acceptSteps_2_1 = acceptSteps_2.next()) {
                        var step = acceptSteps_2_1.value;
                        if (step.finalise) {
                            finalising.push(step.finalise(acceptData));
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (acceptSteps_2_1 && !acceptSteps_2_1.done && (_b = acceptSteps_2.return)) _b.call(acceptSteps_2);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                return $q
                    .all(finalising)
                    .then(function () {
                    acceptData.sessionStartedAt = window.sessionStartTime;
                    di.invoke(AddQuoteDetails_1.default);
                    var telemetryParams = {};
                    if (acceptData.signatureMethod) {
                        telemetryParams.accept_signature_creation_method = acceptData.signatureMethod;
                    }
                    acceptTelemetry.track("Accept Form Accept Button Clicked", telemetryParams);
                    return attemptAccept(acceptData);
                })
                    .catch(function (e) {
                    var _a;
                    var message = ((_a = e.data) === null || _a === void 0 ? void 0 : _a.message) || e.message || "An unexpected error came up";
                    setErrorMsg(message);
                    return $q.reject(e);
                });
            });
        };
        init();
    }
    return SingleAccept;
}());
exports.default = SingleAccept;
